import { useUser } from '@/hooks/useUser';
import { Trans, useTranslation } from 'react-i18next';
import { WelcomeMessageWrapper } from '@/components/chat/WelcomeMessageWrapper';
import { AppIconWithName } from '@/components/ui/icons/AppIconWithName';

export function WelcomeMessage() {
  const user = useUser();
  const { t } = useTranslation('prince');

  return (
    <div className="flex flex-col align-middle items-center h-full justify-center gap-6">
      <AppIconWithName />
      <WelcomeMessageWrapper>
        <Trans
          i18nKey={user ? 'newChat.welcomeMessage' : 'newChat.anonymousWelcomeMessage'}
          values={{
            userName: user?.name,
          }}
          components={[<p className="text-xl font-medium mb-1" />, <p />]}
          t={t}
        />
      </WelcomeMessageWrapper>
    </div>
  );
}
